import { useState } from 'react';
import { UsePrintButtonResult } from './types';

const usePrintButton = (): UsePrintButtonResult => {
  const [displayPrinter, setDisplayPrinter] = useState<boolean>(false);
  const onPrintClick = () => {
    setDisplayPrinter(true);
  };
  const onClose = () => setDisplayPrinter(false);
  return { displayPrinter, onPrintClick, onClose };
};
export { usePrintButton };
